import * as types from '../types/paymentMethodTypes';
import { getActivePaymentMethods } from '../../services/paymentMethodService';

export const fetchActivePaymentMethods = () => async (dispatch) => {
  dispatch({ type: types.FETCH_ACTIVE_PAYMENT_METHODS_REQUEST });
  try {
    const list = await getActivePaymentMethods();
    const payload = Array.isArray(list) ? list : [];
    dispatch({ type: types.FETCH_ACTIVE_PAYMENT_METHODS_SUCCESS, payload });
    return { success: true, methods: payload };
  } catch (error) {
    const msg = error.response?.data?.message || error.message;
    dispatch({ type: types.FETCH_ACTIVE_PAYMENT_METHODS_FAILURE, payload: msg });
    return { success: false, error: msg, methods: [] };
  }
};

export const clearPaymentMethodError = () => (dispatch) => {
  dispatch({ type: types.CLEAR_PAYMENT_METHOD_ERROR });
};
